import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import PagesLayout from 'layout/Pages';
import SimpleLayout from 'layout/Simple';
import { SimpleLayoutType } from 'config';
import UserGuard from 'utils/route-guard/UserGuard';
import { Navigate } from 'react-router';

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const AppContactUS = Loadable(lazy(() => import('pages/contact-us')));
// render - sample page

const ProjectsPage = Loadable(lazy(() => import('pages/extra-pages/projects')));
const DashboardPage = Loadable(lazy(() => import('pages/extra-pages/dashboard')));
const ApiReferencePage = Loadable(lazy(() => import('pages/extra-pages/apiReference')));
// const SettingsPage = Loadable(lazy(() => import('pages/extra-pages/settings')));
const UsageLogsPage = Loadable(lazy(() => import('pages/extra-pages/usageLogs')));
const Unautorized = Loadable(lazy(() => import('pages/maintenance/unautorized')));
// const LoginPage = Loadable(lazy(() => import('pages/extra-pages/login')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element:
        <UserGuard>
          <DashboardLayout />
        </UserGuard>
      ,
      children: [
        {
          index: true, 
          element: <Navigate to="projects" replace /> 
        },
        //  {
        //   path: 'dashboard',
        //   element: <DashboardPage />
        // },
        {
          path: 'projects',
          element: <ProjectsPage />
        },
        {
          path: 'api-reference',
          element: <ApiReferencePage />
        },
        // {
        //   path: 'usage-logs',
        //   element: <UsageLogsPage />
        // },
        {
          path: 'unauthorized',
          element: <Unautorized />
        }
        // {
        //   path: 'login',
        //   element: <LoginPage />
        // },
        // {
        //   path: 'settings',
        //   element: <SettingsPage />
        // }
      ]
    },
    {
      path: '/',
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: 'contact-us',
          element: <AppContactUS />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    },
    {
      path: '*',
      element: <Navigate to="/" replace />
    },
  ]
};

export default MainRoutes;
